import { render, staticRenderFns } from "./apps-docu-page.vue?vue&type=template&id=0f8b61e1&scoped=true"
import script from "./apps-docu-page.vue?vue&type=script&lang=js"
export * from "./apps-docu-page.vue?vue&type=script&lang=js"
import style0 from "./apps-docu-page.vue?vue&type=style&index=0&id=0f8b61e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b61e1",
  null
  
)

export default component.exports